<app-pccrud [endPoint]="'Stock'"></app-pccrud>

